import { createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers';

export const getJobStateSelector = createSelector(fromReducers.getJobState, (state: fromReducers.Job) => state.jobStatus);

export const getJobStatusSummaryState = createSelector(getJobStateSelector, fromReducers.getJobStatusSummary);

export const getJobStatusSummarySearchState = createSelector(getJobStateSelector, fromReducers.getJobStatusSummarySearch);

export const getSelectedJobStatusDetailsState = createSelector(getJobStateSelector, fromReducers.getJobStatusDetails);
